import { OrderItem } from '@components';
import { Container, Icon, Input, Typography } from '@design-system';
import { OrderStatuses } from '@services';
import React from 'react';
import { HiMiniMagnifyingGlass } from 'react-icons/hi2';
import './FavoriteOrdersPage.scss';
import { FavoriteOrdersSkeleton } from './FavoriteOrdersSkeleton';
import { useFavoriteOrdersPageVM } from './useFavoriteOrdersPageVM';

export const FavoriteOrdersPage: React.FC = () => {
    const { orders, isLoading, searchTerm, setSearchTerm } = useFavoriteOrdersPageVM();

    return (
        <div className="favorite-orders-page">
            <Container className="search-container" padding="medium large">
                <Input
                    placeholder=""
                    value={searchTerm}
                    onValueChange={setSearchTerm}
                    className="search-input"
                    icon={<Icon icon={<HiMiniMagnifyingGlass />} size={25} color="grey" />}
                    iconPosition="left"
                />
            </Container>

            {isLoading ? (
                <FavoriteOrdersSkeleton />
            ) : (
                <Container padding="medium" radius="none" className="favorite-orders-page-orders">
                    <div className="favorite-orders-page-orders-list">
                        {orders.length === 0 ? (
                            <Typography intrinsic="p" className="pt-large-spacing">
                                Aucun panier favori trouvé
                            </Typography>
                        ) : (
                            <>
                                {orders.map((order) => (
                                    <OrderItem
                                        key={order.id}
                                        id={order.id}
                                        title={order.title}
                                        products={[]}
                                        customProducts={{ products: order.products }}
                                        isFavorite
                                        id_operator={0}
                                        id_worksite={0}
                                        date_order={new Date().toISOString()}
                                        comment={''}
                                        status={OrderStatuses.FAVORITED}
                                        isPast={true}
                                    />
                                ))}
                            </>
                        )}
                    </div>
                </Container>
            )}
        </div>
    );
};
